var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlocksSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3588_87407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 11H10C10.552 11 11 10.552 11 10V1C11 0.448 10.552 0 10 0H1C0.448 0 0 0.448 0 1V10C0 10.552 0.448 11 1 11Z",
    fill: "#232F6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 0H14C13.448 0 13 0.448 13 1V10C13 10.552 13.448 11 14 11H23C23.552 11 24 10.552 24 10V1C24 0.448 23.552 0 23 0Z",
    fill: "#232F6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 24H10C10.552 24 11 23.552 11 23V14C11 13.448 10.552 13 10 13H1C0.448 13 0 13.448 0 14V23C0 23.552 0.448 24 1 24Z",
    fill: "#232F6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 13H14C13.448 13 13 13.448 13 14V23C13 23.552 13.448 24 14 24H23C23.552 24 24 23.552 24 23V14C24 13.448 23.552 13 23 13Z",
    fill: "#232F6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3588_87407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocksSelected);
export default __webpack_public_path__ + "static/media/blocks-selected.c9e21060e20cc91662c943ae628b0890.svg";
export { ForwardRef as ReactComponent };